import React, { useEffect, useState } from "react";
import AdminAppBar from "../../../components/adminComponents/AdminAppBar";
import CustomHeading from "../../../components/common/CustomHeading";
import CustomButton from "../../../components/common/CustomButton";


import TeamService from "../../Services/TeamService";
import { useLocation, useNavigate } from "react-router-dom";
import CustomSelect from "../../../components/common/CustomSelect";
import { IoSettingsOutline, IoCallOutline } from "react-icons/io5";
import { AiOutlineUser } from "react-icons/ai";
import { managementDepartmentRoles, revenueDepartmentRoles, saleDepartmentRoles } from "../../../GlobalSetupComponents/Enum/RoleEnum";
import { formatDate } from "../../../utils/dateFormatter";
import { showErrorToast, showSuccessToast } from "../../../components/Constant/Notification";
import { userUid } from "../../../utils/storage";
import { ToastContainer } from "react-toastify";
import { validateInput } from "../../../utils/regexValidators";

import GlobalImages from "../../../GlobalSetupComponents/Constant/GlobalImages";
import { sampleDepartmentEnum } from "../../../GlobalSetupComponents/Enum/DepartmentEnum";
import UserService from "../../../GlobalSetupComponents/Services/UserService";

const UserManage = () => {
  const location = useLocation();
  const userData = location.state?.userData || null;
  const id = userData?.id || null;
  const isEditMode = Boolean(id);
  const navigate = useNavigate();

  console.log("userData", userData);

  const [userForm, setUserForm] = useState({
    userName: userData?.name || "",
    employeeId: userData?.employeeId || "",
    email: userData?.emailId || "",
    phoneNumber: userData?.phoneNumber || "",
    department: userData?.department?.name || "",
    team: userData?.teams || null,
    role: userData?.role || "",
    dateOfJoining: formatDate(userData?.dateOfJoining) || "",
    address: userData?.address || "",
    ivrCallAccess: userData?.ivrCallAccess || false,
    ivrPhoneNumber: userData?.ivrPhoneNumber || "",
  });
  const [teamNames, setTeamNames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [triggerDepartment, setTriggerDepartment] = useState(false);

  const [accessModules, setAccessModules] = useState([
    {
      moduleName: "Property Procurement",
      key: "propertyProcurement",
      access: userData?.propertyProcurement || false,
      icon: GlobalImages.procurmentIcon,
      bgColor: "bg-[#DBEAFE] hover:bg-blue-200",
      soon: false,
    },
    {
      moduleName: "GL Funnel CRM",
      key: "glFunnelCrm",
      access: userData?.glFunnelCrm || false,
      icon: GlobalImages.glfunnelIcon,
      bgColor: "bg-[#DCFCE7] hover:bg-green-200",
      soon: false,
    },
    {
      moduleName: "Task Manager",
      key: "taskManager",
      access: userData?.taskManager || false,
      icon: GlobalImages.taskIcon,
      bgColor: "bg-[#F3E8FF] hover:bg-violet-200",
      soon: true,
    },
    {
      moduleName: "GEO Go",
      key: "geoGo",
      access: userData?.geoGo || false,
      icon: GlobalImages.geoIcon,
      bgColor: "bg-[#E0E7FF] hover:bg-blue-200",
      soon: false,
    },
    {
      moduleName: "HR",
      key: "hr",
      access: userData?.hr || false,
      icon: GlobalImages.hrIcon,
      bgColor: "bg-[#FCE7F3] hover:bg-pink-200",
      soon: false,
    },
    {
      moduleName: "Accounts Pro",
      key: "accountsPro",
      access: userData?.accountsPro || false,
      icon: GlobalImages.accountIcon,
      bgColor: "bg-[#FEF9C2] hover:bg-yellow-200",
      soon: true,
    },
  ]);

  useEffect(() => {
   
      getUserId();
    

    if (userForm.department)
    {
      fetchTeamNames();
    }
   
  }, [id , triggerDepartment]);

  useEffect(() => {
    // Set default access based on department
    if (!isEditMode) {
      setAccessModules((prev) =>
        prev.map((module) => {
          if (userForm.department === "Sales" && module.key === "glFunnelCrm") {
            return { ...module, access: true };
          }
          if (userForm.department === "Revenue" && module.key === "propertyProcurement") {
            return { ...module, access: true };
          }
          if (
            userForm.department === "Management" &&
            (module.key === "glFunnelCrm" ||
             module.key === "geoGo" ||
             module.key === "hr" ||
             module.key === "propertyProcurement")
          ) {
            return { ...module, access: true };
          }
          return { ...module, access: false };
        })
      );
    }
  }, [userForm.department, isEditMode]);

  const getUserId = async () => {
    try {
      const response = await UserService.getUser(id);
      if (response.data) {
        const user = response.data;
        setUserForm({
          userName: user.name || "",
          employeeId: user.employeeId || "",
          email: user.emailId || "",
          phoneNumber: user.phoneNumber || "",
          department: user.department?.name || "",
          team: user.team || [],
          role: user.role || "",
          dateOfJoining: formatDate(user.dateOfJoining) || "",
          address: user.address || "",
          ivrCallAccess: user.isIvr || false,
          ivrPhoneNumber: user.ivrPhoneNumber || "",
        });
        setAccessModules((prevModules) =>
          prevModules.map((module) => ({
            ...module,
            access: user[module.key] || false,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      showErrorToast("Failed to fetch user data");
    }
  };

  const fetchTeamNames = async () => {

    try {
      let departmentParam = "";
      if(userForm.role?.label === "MD")
      {
        departmentParam = "Sales";
      }
      else{
        departmentParam = userForm.department;
      }
      const response = await TeamService.getDepartmentTeamList({
        department : departmentParam
      });
      setTeamNames(response.data || []);
    } catch (error) {
      console.error("Error fetching team names:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "department") {
      setUserForm((prev) => ({ ...prev, role: "", team: null }));
    }
    setUserForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAccessToggle = (index) => {
    if (accessModules[index].soon) return;
    setAccessModules((prev) => {
      const newModules = prev.map((module, i) => {
        if (i === index) {
          return { ...module, access: !module.access };
        }
        return module;
      });

      // Auto-toggle HR when GEO is toggled
      const currentModule = newModules[index];
      if (currentModule.key === "geoGo") {
        const hrModuleIndex = newModules.findIndex((mod) => mod.key === "hr");
        if (hrModuleIndex !== -1) {
          newModules[hrModuleIndex] = { 
            ...newModules[hrModuleIndex], 
            access: currentModule.access 
          };
        }
      }

      // Apply mutual exclusivity only for non-Management departments
      if (userForm.department !== "Management") {
        const propertyProcurement = newModules.find((mod) => mod.key === "propertyProcurement");
        const glFunnelCrm = newModules.find((mod) => mod.key === "glFunnelCrm");

        if (propertyProcurement.access && glFunnelCrm.access) {
          showErrorToast("Cannot enable both Property Procurement and GL Funnel CRM.");
          return prev.map((mod, i) =>
            i === index && mod.key === "glFunnelCrm" ? { ...mod, access: false } : mod
          );
        }
      }

      return newModules;
    });
  };

  const handleSubmit = async () => {
    const requiredFields = [
      "userName",
      "employeeId",
      "email",
      "phoneNumber",
      "department",
      "role",
    ];

    for (const field of requiredFields) {
      if (!userForm[field]) {
        showErrorToast(`Please fill ${field} field`);
        return;
      }
    }

    if (userForm.phoneNumber.length > 10 || userForm.phoneNumber.length < 10) {
      showErrorToast("Phone number must be 10 digits");
      return;
    }

    if (!validateInput("email", userForm.email)) {
      showErrorToast("Please enter a valid email address");
      return;
    }
    
    // Only check team requirement for roles other than Admin, CMO, and HR
    if(userForm.role?.label !== "Admin" && userForm.role?.label !== "CMO" && userForm.role?.label !== "HR" ){
      if(!userForm.team || (Array.isArray(userForm.team) && userForm.team.length === 0)){
        showErrorToast("Please select at least one team");
        return; 
      }
    }
    
    // Apply mutual exclusivity only for non-Management departments
    if (userForm.department !== "Management") {
      const hasGlFunnelCrm = accessModules.find((mod) => mod.key === "glFunnelCrm")?.access;
      const hasPropertyProcurement = accessModules.find((mod) => mod.key === "propertyProcurement")?.access;

      if (hasGlFunnelCrm && hasPropertyProcurement) {
        showErrorToast("A user with GL Funnel CRM access cannot have Property Procurement access.");
        return;
      }
    }

    if(userForm.department === "Sales" && !accessModules.find((mod) => mod.key === "glFunnelCrm")?.access){
      showErrorToast("Sales department must have GL Funnel CRM access.");
      return;
    }
    if(userForm.department === "Revenue" && !accessModules.find((mod) => mod.key === "propertyProcurement")?.access){
      showErrorToast("Revenue department must have Property Procurement access.");
      return;
    }


    setLoading(true);
    try {
      const accessPayload = accessModules.reduce((acc, module) => {
        acc[module.key] = module.access;
        return acc;
      }, {});

      const payload = {
        userName: userForm.userName,
        employeeId: userForm.employeeId,
        emailId: userForm.email,
        phoneNumber: Number(userForm.phoneNumber),
        department: userForm.department,
        teams: Array.isArray(userForm.team)
          ? userForm.team.map((team) => team.value)
          : userForm.team
          ? [userForm.team?.value || userForm.team]
          : [],
        role: userForm.role?.label || userForm.role,
        dateOfJoining: formatDate(userForm.dateOfJoining) || "",
        address: userForm.address,
        isIvr: userForm.ivrCallAccess,
        ivrPhoneNumber: userForm.ivrPhoneNumber,
        ...accessPayload,
        ...(isEditMode ? { modifiedById: userUid } : { createdById: userUid }),
      };

      let response;
      if (isEditMode) {
        response = await UserService.updateUser(id, payload);
        if (response.status === 200 || response.status === 201) {
          showSuccessToast(response.data?.message || "User updated successfully");
        }
      } else {
        response = await UserService.createUser(payload);
        if (response.status === 200 || response.status === 201) {
          showSuccessToast(response.data?.message || "User created successfully");
        }
      }

      setTimeout(() => {
        navigate(-1);
      }, 1500);
    } catch (error) {
      console.error("Error submitting form:", error);
      showErrorToast(error?.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-appGrayBackground">
      <AdminAppBar  />
      <ToastContainer />
      <div className="pt-28 px-6 pb-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center gap-3">
            <CustomHeading title={"User Info"} isIcon={true} />
          </div>
          {/* <CustomButton
            isDisabled={loading}
            label={`${isEditMode ? "Update" : "Add"}`}
            onClick={handleSubmit}
            className="w-40"
          /> */}
        </div>

        {/* User Information Section */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
          <div className="flex items-center gap-2 mb-6">
            <AiOutlineUser className="w-5 h-5 text-xl text-blue-500" />
            <h2 className="text-lg font-medium text-gray-700">User Information</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="userName"
                value={userForm.userName}
                maxLength={100}
                disabled
                onChange={handleInputChange}
                placeholder="Enter full name"
                className="w-full p-3 border border-gray-300 rounded-lg input-focus"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Employee ID <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="employeeId"
                maxLength={50}
                value={userForm.employeeId?.toUpperCase()}
                disabled
                onChange={handleInputChange}
                placeholder="Enter employee ID"
                className="w-full p-3 border border-gray-300 rounded-lg input-focus"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email ID <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                name="email"
                disabled
                value={userForm.email}
                onChange={handleInputChange}
                placeholder="user@company.com"
                className="w-full p-3 border border-gray-300 rounded-lg input-focus disabled:bg-gray-100"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Phone Number <span className="text-red-500">*</span>
              </label>
              <input
                type="tel"
                name="phoneNumber"
                maxLength={10}
                value={userForm.phoneNumber}
                disabled
                onChange={(e) => {
                  const re = /^[0-9\b]+$/;
                  if (e.target.value === "" || re.test(e.target.value)) {
                    handleInputChange(e);
                  }
                }}
                placeholder="Enter phone number"
                className="w-full p-3 border border-gray-300 rounded-lg input-focus"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Department <span className="text-red-500">*</span>
              </label>
              <CustomSelect
                disabled
                options={sampleDepartmentEnum}
                value={userForm.department ? { label: userForm.department, value: userForm.department } : null}
                onChange={(value) => {
                  setUserForm((prev) => ({ ...prev, department: value?.label || "", role: "", team: null }));
                }}
                placeholder="Select department"
                className="w-full"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Role <span className="text-red-500">*</span>
              </label>
              <CustomSelect
                disabled
                options={
                  userForm.department === "Sales"
                    ? saleDepartmentRoles
                    : userForm.department === "Management"
                    ? managementDepartmentRoles
                    : revenueDepartmentRoles
                }
                value={userForm.role}
                onChange={(value) => {
                  setUserForm((prev) => ({ ...prev, role: value }));
                  setTriggerDepartment((prev) => !prev);
                  setUserForm((prev) => ({ ...prev, team: null }));
                }}
                placeholder={`${userForm.department ? "Select role" : "Select department first"}`}
                className="w-full"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Team <span className="text-red-500">*</span>
              </label>
              <CustomSelect
                options={teamNames}
                value={userForm.team}
                disabled
                isMulti={userForm.role?.label === "MD"}
                onChange={(option) => setUserForm((prev) => ({ ...prev, team: option }))}
                placeholder={
                  userForm.role?.label === "Admin" || userForm.role?.label === "CMO" 
                    ? "Admin/CMO cannot be assigned to a team"
                    : userForm.role?.label === "MD"
                    ? "Select multiple teams" 
                    : userForm.role?.label === "HR"
                    ? "HR cannot be assigned to a team"
                    : userForm.role 
                    ? "Select team"
                    : "Select role first"
                }
                className="w-full"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Date of Joining
              </label>
              <input
                type="date"
                name="dateOfJoining"
                value={userForm.dateOfJoining}
                disabled
                onChange={handleInputChange}
                max={new Date().toISOString().split("T")[0]}
                className="w-full p-3 border border-gray-300 rounded-lg input-focus"
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Address
              </label>
              <textarea
                name="address"
                value={userForm.address}
                disabled
                onChange={handleInputChange}
                placeholder="Enter full address"
                rows="3"
                className="w-full p-3 border border-gray-300 rounded-lg input-focus"
              />
            </div>
          </div>
        </div>

        {/* IVR Call Access Section */}
        {userForm.department === "Sales" && (
          <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
            <div className="flex items-center justify-between">
              <div className="flex gap-3">
                <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center">
                  <IoCallOutline className="w-5 h-5 text-emerald-500" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-800">IVR Call Access</h3>
                  <p className="text-sm text-gray-600">
                    Allow this user to make and receive calls through the IVR system
                  </p>
                </div>
              </div>

              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  name="ivrCallAccess"
                  checked={userForm.ivrCallAccess}
                  disabled
                  onChange={handleInputChange}
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-emerald-300 peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full peer-checked:after:border-white"></div>
              </label>
            </div>
          </div>
        )}

        {/* Access Modules Section */}
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <div className="flex items-center gap-2 mb-6">
            <IoSettingsOutline className="w-5 h-5 text-violet-500" />
            <h2 className="text-lg font-medium text-gray-700">Access Modules</h2>
          </div>
          <p className="text-sm text-gray-600 mb-6">Select which modules the user can access</p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {accessModules.map((module, index) => {
              const isDisabled =
                userForm.department !== "Management" &&
                ((module.key === "glFunnelCrm" &&
                  accessModules.find((mod) => mod.key === "propertyProcurement")?.access) ||
                 (module.key === "propertyProcurement" &&
                  accessModules.find((mod) => mod.key === "glFunnelCrm")?.access));

              return (
                <div
                  key={index}
                  className={`border-2 rounded-lg p-4 transition-all relative ${
                    module.access ? "border-emerald-500 bg-emerald-50" : "border-gray-200 bg-white hover:border-gray-300"
                  } ${isDisabled || module.soon ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                  onClick={() => {}}
                >
                  {module.soon && (
                    <span className="absolute top-2 right-2 bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded">
                      Coming Soon
                    </span>
                  )}
                  <div className="flex items-center justify-between mb-3">
                    <div className={`p-2 rounded ${module.bgColor}`}>
                      {module.icon ? (
                        <img src={module.icon} alt={module.moduleName} className="w-6 h-6" />
                      ) : (
                        <div className="w-6 h-6 bg-blue-500 rounded"></div>
                      )}
                    </div>
                    {!module.soon && (
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={module.access}
                          disabled
                          onChange={() => {}}
                          className="sr-only peer"
                        />
                        <div
                          className={`w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-emerald-300 rounded-full peer after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-emerald-600 peer-checked:after:translate-x-full peer-checked:after:border-white`}
                        ></div>
                      </label>
                    )}
                  </div>
                  <h4 className="font-medium text-gray-800 text-sm mb-1">{module.moduleName}</h4>
                  <p className="text-xs text-gray-500">Access {module.access ? "Enabled" : "Disabled"}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserManage;